import GenericRequest, { METHOD_GET } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export default class TaskStatesRequest extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.TASK_STATES);
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/ws/TaskStatesRequest.js